import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerTransactionActions } from "../../actions/consumer-log.actions";
import { AchDocumentState } from "../../models/consumer-logs/ach-document-state";

const initialState: AchDocumentState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerTransactionActions.achDocs.getApi, (state) => ({ ...state, loading: true })),
	on(ConsumerTransactionActions.achDocs.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type")
	})),
	on(ConsumerTransactionActions.achDocs.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function achDocumentReducer(state: AchDocumentState | undefined, action: Action) {
	return reducer(state, action);
}
